export const specialists = [
    {
        image: "https://listkit.cssninja.io/img/photo/avatar/9.jpg",
        icon: "https://images.pexels.com/photos/8436729/pexels-photo-8436729.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
        name: "Dr. Mark Olusegun",
        specialty: "Family Medicine",
        username: "dr-mark-olusegun",
        rating: 3
    },
    {
        image: "https://listkit.cssninja.io/img/photo/avatar/7.jpg",
        icon: "https://images.pexels.com/photos/1220757/pexels-photo-1220757.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        name: "Dr. Ben Aliyu",
        specialty: "Prostate Removal",
        username: "dr-ben-aliyu",
        rating: 4
    },
    {
        image: "https://listkit.cssninja.io/img/photo/avatar/12.jpg",
        icon: "https://images.pexels.com/photos/9951390/pexels-photo-9951390.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        name: "Dr. Daniel Asuquo",
        specialty: "General Medicine",
        username: "dr-daniel-asuquo",
        rating: 3
    },
    {
        image: "https://listkit.cssninja.io/img/photo/avatar/11.jpg",
        icon: "https://images.pexels.com/photos/9951405/pexels-photo-9951405.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        name: "Dr. Sam Amadi",
        specialty: "General Medicine",
        username: "dr-daniel-asuquo",
        rating: 3
    },
]